// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"7279f0b1","198":"98547380","278":"c1d888d1","500":"b2ec5989","899":"6486eb12"}[chunkId] + ".css";
};